import { StripeTerminalError } from './StripeTerminalError';

export class StripeTerminalPasscodeNotEnabledError extends StripeTerminalError {
  constructor(message: unknown) {
    super(message);
    this.name = 'StripeTerminalPasscodeNotEnabledError';
  }
}
